import React from "react";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";
import { useTranslation } from "src/context/Translations/context";
import { GroupersOKR } from "src/pages/StrategicPlanning/Okr/interface";

const LovGrouperOKRs: React.FC<Omit<IComponentSelect, "options">> = ({
	name,
	label,
	control,
	...rest
}) => {
	const {translate} = useTranslation();
	return (<Select 
		name={name}
		control={control}
		label={label ?? translate("Agrupadores")}
		options={[
			{ value: GroupersOKR.RESPONSIBLE, label: `${translate("Responsável")}` },
			{ value: GroupersOKR.AUTHORITY, label: `${translate("Autoridade")}` },
			{ value: GroupersOKR.LEVEL, label: `${translate("Nível")}` },
			{ value: GroupersOKR.SECTOR, label: `${translate("Setor")}` },
			{ value: GroupersOKR.PERIOD, label: `${translate("Período")}` }
		]}
		{...rest}
	/>);
};

export default LovGrouperOKRs;
